import { Img, Text } from "components";

const badgeClass = `
  px-3 py-1
  text-xs font-medium
  flex items-center gap-1
  rounded-full
  border border-[#F3F3F3]
  bg-[rgba(253,242,246,0.40)]
  shadow-[2px_5px_106px_16px_rgba(26,26,26,0.12)]
  whitespace-nowrap
  z-10
`;

const ReelCard = ({
  image,
  views = "50K+ Views",
  tag = "Viral Hit",
  popularity = "Most Popular",
  followers = "+2k Followers",
  brand = "Rabbit Hole",
}) => {
  return (
    <div className="relative w-[300px] h-[520px] rounded-[24px] overflow-hidden bg-black shadow-xl">

      {/* IMAGE */}
      <img
        src={image}
        alt="reel"
        className="w-full h-full object-cover"
      />

      {/* Views */}
      <div className={`absolute top-4 left-1/2 -translate-x-1/2 ${badgeClass}`}>
        👁 {views}
      </div>

      {/* Viral tag */}
      <div className={`absolute left-3 top-1/2 -translate-y-1/2 ${badgeClass}`}>
        <Img
          src="/images/icon_misc.svg"
          className="w-6 h-6 rounded-full bg-[#ffffff] p-1"
          alt="logo"
        /> {tag}
      </div>

      {/* Popular */}
      <div className={`absolute right-[0%] top-[35%] z-20 ${badgeClass}`}>
      <Img
          src="/images/popular.svg"
          className="w-6 h-6 rounded-full bg-[#ffffff] p-1"
          alt="logo"
        /> {popularity}
      </div>

      {/* Followers */}
      <div className={`absolute right-3 bottom-[80px] ${badgeClass}`}>
        👥 {followers}
      </div>

      {/* Brand */}
      <div className="absolute bottom-5 left-3 flex items-center gap-2 text-white">
        <Img
          src="/images/logo.svg"
          className="w-6 h-6 rounded-full bg-[#ffffff] p-1"
          alt="logo"
        />
        <Text className={`text-sm font-medium text-[#ffffff] ${badgeClass}`}>{brand}</Text>
      </div>
    </div>
  );
};

export default ReelCard;

